import form from '@/mixins/crud-form';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'MARKET_DETAIL',
        create: 'MARKET_CREATE',
        update: 'MARKET_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'market_mobile',
        default: '',
        label: 'market_mobile',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.market_mobile,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "market_mobile", $$v);
              }
            }
          });
        }
      }, {
        prop: 'market_password',
        default: '',
        label: 'market_password',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.market_password,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "market_password", $$v);
              }
            }
          });
        }
      }, {
        prop: 'user_name',
        default: '',
        label: 'user_name',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.user_name,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "user_name", $$v);
              }
            }
          });
        }
      }, {
        prop: 'company',
        default: '',
        label: 'company',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.company,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "company", $$v);
              }
            }
          });
        }
      }];
    }
  }
};